import { VerticalListCSSStyle, VerticalListCSSStyleImpl } from '../verticallist/verticallistcss';

export interface DropDownListCSSStyle extends VerticalListCSSStyle
{
}

export class DropDownListCSSStyleImpl extends VerticalListCSSStyleImpl implements DropDownListCSSStyle
{
    // getPaginationCSSStyle(): object 
    // {
    //     return {
    //         height: "50px",
    //         width: "100%",
    //         marginTop: "50px"
    //     };
    // }

    getWrapperCSSStyle():object
    {
        return{
            listStyleType: "none",
            width: "100%",
            // height: "100%",
            display: "flex",
            flexFlow: "row wrap",
            // borderRadius:'0px 0px 8px 8px',
            // border: '1px solid #EAECEF'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dropdownlist/dropdownlistcss.tsx